module.exports = __webpack_public_path__ + "img/6.dbb70259.png";